import { NotificationTheme } from '../../types';

export const NOTIFICATION_DEFAULT_THEME: NotificationTheme = {
    borderWidth: 1,
    elementShades: {
        background: 'lightest',
        border: 'light',
        icon: 'base',
    },
    textColor: 'common.black',
    variant: {
        default: {
            padding: {
                x: 16,
                y: 16,
            },
            iconSize: 20,
            iconClearance: 8,
            dismissButtonClearance: 16,
            radius: 10,
            fontSize: 's',
            contentSpacing: 4,
        },
        compact: {
            padding: {
                x: 12,
                y: 8,
            },
            iconSize: 20,
            iconClearance: 8,
            dismissButtonClearance: 16,
            radius: 10,
            fontSize: 's',
            contentSpacing: 4,
        },
    },
};
